module.exports = __webpack_public_path__ + "static/media/reactnative.3b206938.png";